import { useQuery } from '@tanstack/react-query';
import { getObraById, getObraBalanco } from '../services/api';

export const useObraDetails = (id: string | undefined) => {
    const {
        data: obra,
        isLoading: loadingObra,
        error: errorObra,
        refetch: refetchObra
    } = useQuery({
        queryKey: ['obra', id],
        queryFn: () => getObraById(Number(id)),
        enabled: !!id,
    });

    const {
        data: balanco,
        isLoading: loadingBalanco,
        error: errorBalanco,
        refetch: refetchBalanco
    } = useQuery({
        queryKey: ['obra-balanco', id],
        queryFn: () => getObraBalanco(Number(id)),
        enabled: !!id,
    });

    const loading = loadingObra || loadingBalanco;
    const error = errorObra ? (errorObra as Error).message : (errorBalanco ? (errorBalanco as Error).message : null);

    const refetch = () => {
        refetchObra();
        refetchBalanco();
    };

    return { obra, balanco, loading, error, refetch };
};
